(() => {
  function initialize(root) {
    if (root.dataset.designInitialized) return;
    root.dataset.designInitialized = 'true';
    const cleanup = [];
    root.querySelectorAll('[data-vm-scroll-controls]').forEach(controls => {
      const track = root.querySelector('#' + controls.dataset.target);
      if (!track) return;
      const previous = controls.querySelector('[data-scroll-direction="-1"]');
      const next = controls.querySelector('[data-scroll-direction="1"]');
      const position = controls.querySelector('.vm-scroll-position');
      const reviews = controls.dataset.vmScrollControls === 'reviews';
      let frame;
      function update() {
        const maximum = track.scrollWidth - track.clientWidth;
        controls.dataset.overflow = String(maximum > 4);
        previous.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= maximum - 4;
        if (position) {
          const cards = [...track.children];
          const left = track.getBoundingClientRect().left;
          const current = cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? index : best, 0) + 1;
          position.textContent = current + ' / ' + cards.length;
          position.setAttribute('aria-label', controls.dataset.positionTemplate.replace('{current}', current).replace('{total}', cards.length));
        }
      }
      function queueUpdate() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }
      controls.addEventListener('click', event => {
        const button = event.target.closest('[data-scroll-direction]');
        if (!button || button.disabled) return;
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = reviews ? track.firstElementChild.getBoundingClientRect().width + gap : track.querySelector('thead th:nth-child(2)').getBoundingClientRect().width;
        track.scrollBy({left: Number(button.dataset.scrollDirection) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
      track.addEventListener('scroll', queueUpdate, {passive: true});
      const observer = new ResizeObserver(queueUpdate);
      observer.observe(track);
      cleanup.push(() => { observer.disconnect(); cancelAnimationFrame(frame); });
      update();
    });
    const section = root.closest('.shopify-section');
    section?.addEventListener('shopify:section:unload', () => cleanup.forEach(dispose => dispose()), {once: true});
  }
  function initializeAll() { document.querySelectorAll('.vm-design-refresh').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll); else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
